import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "New Box"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-new-box',
    templateUrl: './icon-new-box.component.html',
    styleUrls: ['./icon-new-box.component.scss'],
    standalone: false
})
export class IconNewBoxComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
